/**Select status* */
export const SET_SELECT_STATUS = (payload: any) => ({
    type: "SET_SELECT_STATUS",
    payload,
})
